// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-container {\n  padding-top: 50px;\n  min-height: 500px;\n}", ""]);
// Exports
module.exports = exports;
